import { useAccount, useAuth } from '@retainerclub/hooks';
import { useEffect, useState } from 'react';
import DashboardLayoutTitleWithPartner from '../../layouts/DashboardLayout/DashboardLayoutTitleWithPartner';
import DashboardBanners from './DashboardBanners/DashboardBanners';
import DashboardPatients from './DashboardPatients/DashboardPatients';
import DashboardSchedules from './DashboardSchedules/DashboardSchedules';
import DashboardShipments from './DashboardShipments/DashboardShipments';
import DashboardSubscriptions from './DashboardSubscriptions/DashboardSubscriptions';
import ManageSubscriptionModal from './DashboardSubscriptions/ManageSubsciptionModal/ManageSubscriptionModal';
import DashboardTransactions from './DashboardTransactions/DashboardTransactions';

function Dashboard() {
  const { accountRefetch } = useAccount();
  const { currentUser } = useAuth();
  const [manageSubscriptionOpen, setManageSubscriptionOpen] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(null);

  useEffect(() => {
    accountRefetch();
  }, [accountRefetch]);

  function handleOpenManageSubscription(subscription) {
    setActiveSubscription(subscription);
    setManageSubscriptionOpen(true);
  }

  function handleCloseManageSubscription() {
    setManageSubscriptionOpen(false);
    setActiveSubscription(null);
    accountRefetch();
  }

  return (
    <>
      <DashboardLayoutTitleWithPartner
        heading="Welcome back"
        title={`${currentUser?.firstName}`}
        subtitle="How can we help you today?"
      />
      <DashboardBanners />
      <DashboardPatients
        handleOpenManageSubscription={handleOpenManageSubscription}
      />
      <DashboardSubscriptions
        handleOpenManageSubscription={handleOpenManageSubscription}
      />
      <DashboardShipments />
      <div className="flex flex-col gap-4 lg:flex-row">
        <div className="w-full lg:w-1/2">
          <DashboardSchedules />
        </div>
        <div className="w-full lg:w-1/2">
          <DashboardTransactions />
        </div>
      </div>
      <ManageSubscriptionModal
        open={manageSubscriptionOpen}
        handleCloseModal={handleCloseManageSubscription}
        activeSubscription={activeSubscription}
        refetch={accountRefetch}
      />
    </>
  );
}

export default Dashboard;
